<div class="container mx-auto mt-1">
  <!-- Booking Details - Mini view -->
  <div class="custom-margin relative flex flex-col min-w-0 break-words bg-slate-50 shadow-md rounded-2xl bg-clip-border"
    *ngIf="!bookingDetails.booking_completely_rescheduled && !bookingDetails.is_cancelled">
    <div class="flex-auto p-4">
      <div class="flex flex-wrap -mx-3">
        <div class="max-w-full px-3 lg:flex-none">
          <div class="flex flex-col h-full">
            <h4 class="pt-2 mb-1 font-semibold text-red-700">Booking Details</h4>
            <h5 class="font-bold mb-0">Booking No: {{bookingDetails.booking_no}}</h5>
            <h5 class="font-bold mb-0 text-red-700">Country: {{bookingDetails.slot.entity}}</h5>
            <span class="text-sm mt-0">Booked on: {{bookingDetails.created_at | date:'dd-MMMM-yyyy'}}</span>
            <span class="text-sm mt-0">Slot on: {{bookingDetails.slot.start_time | date:'dd-MMMM-yyyy'}}</span>
            <p class="text-xs">
              E-mail: {{bookingDetails.email}}
              <br />Phone: {{bookingDetails.phone}}
            </p>
            <a (click)="goToBookingDetails()"
              class="mt-auto mb-0 font-semibold leading-normal text-sm group text-red-700" href="javascript:;">
              View Details
              <i
                class="fas fa-arrow-right ease-bounce text-sm group-hover:translate-x-1.25 ml-1 leading-normal transition-all duration-200"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Booking Details Completely Reschedule - Mini view -->
  <div class="custom-margin relative flex flex-col min-w-0 break-words bg-slate-50 shadow-md rounded-2xl bg-clip-border"
    *ngIf="bookingDetails.booking_completely_rescheduled relative">
    <div class="flex-auto p-4">
      <div class="flex flex-wrap -mx-3">
        <div class="max-w-full px-3 lg:flex-none">
          <div class="flex flex-col h-full">
            <h4 class="pt-2 mb-1 font-semibold text-red-700">Booking Details</h4>
            <h5 class="font-bold mb-0">Booking No: {{bookingDetails.booking_no}}</h5>
            <h5 class="font-bold mb-0 text-red-700">Country: {{bookingDetails.slot.entity}}</h5>
            <span class="text-sm mt-0">Booked on: {{bookingDetails.created_at | date:'dd-MMMM-yyyy'}}</span>
            <span class="text-sm mt-0">Slot on: {{bookingDetails.slot.start_time | date:'dd-MMMM-yyyy'}}</span>
            <p class="text-xs">
              E-mail: {{bookingDetails.email}}
              <br />Phone: {{bookingDetails.phone}}
            </p>
            <p
              class="mt-auto mb-0 leading-normal text-xs group absolute top-[1em] right-0 text-white py-[0.5em] px-[0.5em] bg-red-700">
              Rescheduled
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Booking Details Cancelled - Mini view -->
  <div class="custom-margin relative flex flex-col min-w-0 break-words bg-slate-50 shadow-md rounded-2xl bg-clip-border"
    *ngIf="bookingDetails.is_cancelled">
    <div class="flex-auto p-4">
      <div class="flex flex-wrap -mx-3">
        <div class="max-w-full px-3 lg:flex-none">
          <div class="flex flex-col h-full">
            <h4 class="pt-2 mb-1 font-semibold text-red-700">Booking Details</h4>
            <h5 class="font-bold mb-0">Booking No: {{bookingDetails.booking_no}}</h5>
            <h5 class="font-bold mb-0 text-red-700">Country: {{bookingDetails.slot.entity}}</h5>
            <span class="text-sm mt-0">Booked on: {{bookingDetails.created_at | date:'dd-MMMM-yyyy'}}</span>
            <span class="text-sm mt-0">Slot on: {{bookingDetails.slot.start_time | date:'dd-MMMM-yyyy'}}</span>
            <p class="text-xs">
              E-mail: {{bookingDetails.email}}
              <br />Phone: {{bookingDetails.phone}}
            </p>
            <p
              class="mt-auto mb-0 leading-normal text-xs group  absolute top-[1em] right-0 text-white py-[0.5em] px-[0.5em] bg-red-700">
              Cancelled
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>